export const DATA_CHANGED_EVENT = "hub-financeiro-data-changed";

const READ_METHODS = new Set(["GET", "HEAD", "OPTIONS"]);

export function isWriteRequest(options = {}) {
  const method = String(options.method || "GET").toUpperCase();
  return !READ_METHODS.has(method);
}

export function notifyDataChanged(path, options, response) {
  if (!response?.ok || !isWriteRequest(options) || typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(DATA_CHANGED_EVENT, {
    detail: { path, method: String(options?.method || "GET").toUpperCase() },
  }));
}
